import React from "react";
import { Button } from "@/components/ui/button";

const CTASection = () => {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-[#8932c8]/10 via-background to-[#8932c8]/5">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground">
            Experience AuraXP
          </h2>
          <p className="text-xl text-muted-foreground">
            See how your organization's cyber intelligence can think, remember, and act autonomously. Schedule a live demo and experience the future of AI-driven cybersecurity today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button
              size="lg"
              className="bg-[#8932c8] hover:bg-[#8932c8]/90 text-white font-semibold px-8 py-6 text-lg"
              onClick={() => window.open('https://outlook.office.com/bookwithme/user/3c14c6b9047b45dfb64e4bc9045f29dd@spharaka.com/meetingtype/p0-SnGKD_EqEPlSvi_wdNg2?anonymous&ismsaljsauthenabled&ep=mlink', '_blank')}
            >
              Book a Demo
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-[#8932c8] text-[#8932c8] hover:bg-[#8932c8]/10 font-semibold px-8 py-6 text-lg"
              onClick={() => window.open('/contact', '_blank')}
            >
              Partner with Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;